import React, { useState } from 'react';
import {
  HoverValue,
  Star,
  StarHalf,
  StarsQuestion,
  StarsRow,
  StarWrap,
} from './styles';

interface StarRatingProps {
  rating: number;
  onSetRating: (n: number) => void;
}

const StarRating: React.FC<StarRatingProps> = ({ rating, onSetRating }) => {
  const [hoverValue, setHoverValue] = useState<number | null>(null);

  const valueFromEvent = (
    e: React.MouseEvent<HTMLElement>,
    i: number,
  ): number => {
    const rect = e.currentTarget.getBoundingClientRect();
    const isLeftHalf = e.clientX - rect.left < rect.width / 2;
    return isLeftHalf ? i - 0.5 : i;
  };

  const displayRating = hoverValue ?? rating;

  return (
    <>
      <StarsRow onMouseLeave={() => setHoverValue(null)}>
        {[1, 2, 3, 4, 5].map(i => {
          const full = displayRating >= i;
          const half = !full && displayRating >= i - 0.5;
          return (
            <StarWrap
              key={i}
              onMouseMove={e => setHoverValue(valueFromEvent(e, i))}
              onClick={e => onSetRating(valueFromEvent(e, i))}
            >
              <Star $on={full}>★</Star>
              {half && (
                <StarHalf>
                  <Star $on>★</Star>
                </StarHalf>
              )}
            </StarWrap>
          );
        })}
        {hoverValue !== null && (
          <HoverValue>
            {hoverValue % 1 === 0 ? hoverValue : hoverValue.toFixed(1)}
          </HoverValue>
        )}
      </StarsRow>
      <StarsQuestion>Wie leben wir das aktuell im Unternehmen?</StarsQuestion>
    </>
  );
};

export default StarRating;
